const breadCrumb = "Lotação de Servidores - Diretores e Secretários";

const routes = [
  {
    path: "/manutencao-motivo-exoneracao",
    name: "manutencao-motivo-exoneracao",
    meta: {
      allowedPermissions: ["motivo_afastamento_nomeacao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ManutencaoExoneracao/ManutencaoExoneracaoHome.vue"),
  },
  {
    path: "/manutencao-motivo-exoneracao/novo",
    name: "manutencao-motivo-exoneracao-novo",
    meta: {
      allowedPermissions: ["motivo_afastamento_nomeacao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ManutencaoExoneracao/ManutencaoExoneracaoCad.vue"),
  },
  {
    path: "/manutencao-motivo-exoneracao/editar/:id",
    name: "manutencao-motivo-exoneracao-editar",
    meta: {
      allowedPermissions: ["motivo_afastamento_nomeacao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ManutencaoExoneracao/ManutencaoExoneracaoEdit.vue"),
  },
];

export default routes;
